import React from 'react';
import { ArrowDown } from '@phosphor-icons/react';

/**
 * Pill banner that appears at the bottom of the chat column after a
 * reconnect delivered messages the user hasn't seen yet.
 *
 * Clicking scrolls the chat list to the bottom and dismisses the banner.
 * Parent is responsible for computing count (diff between REST snapshot
 * length at reconnect time and the pre-reconnect messages length).
 */

interface Props {
  count: number;
  onClick: () => void;
}

const NewMessagesBanner: React.FC<Props> = ({ count, onClick }) => {
  if (count <= 0) return null;
  return (
    <button
      onClick={onClick}
      style={{
        position: 'absolute',
        bottom: 72,
        left: '50%',
        transform: 'translateX(-50%)',
        background: 'var(--brand)',
        color: 'var(--ds-on-accent)',
        border: 'none',
        borderRadius: 16,
        padding: '6px 14px',
        fontSize: 'var(--fs-sm)',
        fontFamily: 'inherit',
        cursor: 'pointer',
        boxShadow: '0 2px 8px var(--ds-shadow-color)',
        display: 'flex',
        alignItems: 'center',
        gap: 6,
        zIndex: 10,
      }}
      aria-label={`${count} new messages — jump to bottom`}
    >
      <ArrowDown size={12} weight="bold" />
      <span>{count} new message{count === 1 ? '' : 's'}</span>
    </button>
  );
};

export default NewMessagesBanner;
